<ion-item-group>
  <ion-item>
    <ion-label translate>Control Unit mode</ion-label>
    <ion-checkbox [(ngModel)]="mode"></ion-checkbox>
  </ion-item>
  <ion-item button (click)="applyAll()">
    <ion-label translate>Apply all</ion-label>
  </ion-item>
</ion-item-group>
